"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var DrivesFilterService = /** @class */ (function () {
    function DrivesFilterService(CalendarModel) {
        this.CalendarModel = CalendarModel;
        /**
         * The collection to be sent to the calendar/agenda
         * @type array
         */
        this.items = [];
        this.agenda = [];
        /**
         * Filter parameters object
         */
        this.filterParams = {
            'status': 'all'
        };
        /**
         * Object of filter option arrays
         */
        this.filterOptions = {
            'services': [],
            'courses': [],
            'instructors': [],
            'locations': [],
            'sectors': [],
            'classrooms': [],
            'vehicles': [],
            'filterLocations': [],
            'days': 'all', // for the student filter
            'times': 'all' // for the student filter
        };
        this.month = (0, moment_1.default)().format('M');
        this.year = (0, moment_1.default)().format('YYYY');
        this.clearFilterOptions = this.clearFilterOptions.bind(this);
        this.setMonth = this.setMonth.bind(this);
        this.setYear = this.setYear.bind(this);
        this.setDate = this.setDate.bind(this);
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
        this.getDate = this.getDate.bind(this);
        this.getMonth = this.getMonth.bind(this);
        this.getYear = this.getYear.bind(this);
        this.getStartDate = this.getStartDate.bind(this);
        this.getEndDate = this.getEndDate.bind(this);
        this.getFilterOptions = this.getFilterOptions.bind(this);
        this.setFilterOptions = this.setFilterOptions.bind(this);
        this.setFilterParameters = this.setFilterParameters.bind(this);
        this.getFilterParameters = this.getFilterParameters.bind(this);
        this.clearFilterParameters = this.clearFilterParameters.bind(this);
        this.setAgenda = this.setAgenda.bind(this);
        this.getAgenda = this.getAgenda.bind(this);
    }
    /**
     * Clear the filter options and reset them to the default empty object/arrays
     */
    DrivesFilterService.prototype.clearFilterOptions = function () {
        this.filterOptions = {
            'services': [],
            'courses': [],
            'instructors': [],
            'locations': [],
            'sectors': [],
            'classrooms': [],
            'vehicles': [],
            'filterLocations': [],
            'days': 'all', // for the student filter
            'times': 'all' // for the student filter
        };
        this.month = (0, moment_1.default)().format('M');
        this.year = (0, moment_1.default)().format('YYYY');
        return this.filterOptions;
    };
    DrivesFilterService.prototype.setMonth = function (data) {
        this.month = data;
    };
    DrivesFilterService.prototype.setYear = function (data) {
        this.year = data;
    };
    DrivesFilterService.prototype.getMonth = function () {
        return this.month;
    };
    DrivesFilterService.prototype.getYear = function () {
        return this.year;
    };
    DrivesFilterService.prototype.setDate = function (date) {
        this.filterParams.date = date;
    };
    DrivesFilterService.prototype.getDate = function () {
        return this.filterParams.date;
    };
    DrivesFilterService.prototype.setStartDate = function (data) {
        this.startDate = data;
    };
    DrivesFilterService.prototype.getStartDate = function () {
        return (0, moment_1.default)(this.startDate).format('YYYY-MM-DD');
    };
    DrivesFilterService.prototype.setEndDate = function (data) {
        this.endDate = data;
    };
    DrivesFilterService.prototype.getEndDate = function () {
        return (0, moment_1.default)(this.endDate).format('YYYY-MM-DD');
    };
    /**
     * Get the filter options
     * @returns CalendarFilterOptions
     */
    DrivesFilterService.prototype.getFilterOptions = function () {
        return this.filterOptions;
    };
    /**
     * Prepares the filter options object used to determin what the admin can filter the calendar by
     * @param data
     * @returns CalendarFilterOptions
     */
    DrivesFilterService.prototype.setFilterOptions = function (data) {
        this.filterOptions = data;
        return this.filterOptions;
    };
    /**
     * Set the filter parameters
     * @param params
     */
    DrivesFilterService.prototype.setFilterParameters = function (params) {
        this.filterParams = params;
    };
    /**
     * Return the currently set filter parameters
     */
    DrivesFilterService.prototype.getFilterParameters = function () {
        return this.filterParams;
    };
    /**
     * Clear the filter parameters
     */
    DrivesFilterService.prototype.clearFilterParameters = function () {
        this.filterParams = {
            'status': 'all'
        };
        this.month = (0, moment_1.default)().format('M');
        this.year = (0, moment_1.default)().format('YYYY');
    };
    /**
     * Set agenda items for admin dashboard
     */
    DrivesFilterService.prototype.setAgenda = function (data) {
        this.agenda = data;
        this.CalendarModel.setAgenda(data);
        return this.agenda;
    };
    /**
     * Get agenda items for admin dashboard
     */
    DrivesFilterService.prototype.getAgenda = function () {
        return this.agenda;
    };
    return DrivesFilterService;
}());
DrivesFilterService.$inject = ['CalendarModel'];
exports.default = DrivesFilterService;
